import { render } from "./ChooseModal.vue?vue&type=template&id=44486031"
import script from "./ChooseModal.vue?vue&type=script&lang=js"
export * from "./ChooseModal.vue?vue&type=script&lang=js"

import "./ChooseModal.vue?vue&type=style&index=0&id=44486031&lang=css"

import exportComponent from "D:\\VueJs project\\product\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__